
    <div #container class="modal fade" style="display:block !important;" role="dialog">
        <template #element></template>
    </div>
